/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV3ServiceGetReceiptIdGet } from '../fn/receipt/api-v-3-service-get-receipt-id-get';
import { ApiV3ServiceGetReceiptIdGet$Params } from '../fn/receipt/api-v-3-service-get-receipt-id-get';

@Injectable({ providedIn: 'root' })
export class ApiFromReceiptService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV3ServiceGetReceiptIdGet()` */
  static readonly ApiV3ServiceGetReceiptIdGetPath = '/api/v3/service/GetReceipt/{id}';

  /**
   * Getting data for a check.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceGetReceiptIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetReceiptIdGet$Response(params: ApiV3ServiceGetReceiptIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiV3ServiceGetReceiptIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting data for a check.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceGetReceiptIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetReceiptIdGet(params: ApiV3ServiceGetReceiptIdGet$Params, context?: HttpContext): Observable<void> {
    return this.apiV3ServiceGetReceiptIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
